module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-btn u-relative u-inline-block u-cursor-pointer",
    class: [_vm.selected ? 'is-selected' : ''],
    attrs: {
      "href": _vm.to,
      "target": _vm.target
    },
    on: {
      "mouseenter": _vm._onMouseEnter,
      "mouseleave": _vm._onMouseLeave,
      "click": function($event) {
        $event.preventDefault();
        _vm._onMouseClick($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-btn__container u-fit-w t-text--sm u-uppercase u-force-3d"
  }, [_c('div', {
    staticClass: "c-btn__bg u-absolute u-pos-tl u-fit"
  }), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-btn__background u-absolute u-pos-tl u-fit u-overflow-h"
  }, [_c('div', {
    staticClass: "c-btn__light c-btn__light--tl u-absolute u-pos-tl"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-btn__light c-btn__light--br u-absolute u-pos-br"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba3ea6d"}!./src/scripts/components/app-btn/template.html
// module id = 913
// module chunks = 0